module.exports = __webpack_public_path__ + "img/news16_4.e4cc4c36.jpg";